module.exports = __webpack_public_path__ + "static/media/2.443fdb8d.png";